/**
 * The phone a post went out on, as a way to it (owner 2026-10-13: "біля постів показуй на якому телефоні
 * вони, щоб можна було тикнути і одразу на телефон перейти"): opens the Phones section with it picked.
 * A phone no longer in the farm is just its name.
 */

import { Smartphone } from 'lucide-react'
import { Link } from 'react-router-dom'

import { useT } from '../i18n'

export function PhoneLink({ deviceId, name, serial }: { deviceId?: string | null; name?: string | null; serial?: string | null }) {
  const openPhone = useT().dash.openPhone
  const label = name || serial || '—'
  const body = <><Smartphone className="ico" size={12} aria-hidden /><span className="phone-link-name">{label}</span></>
  if (!deviceId) return <span className="phone-link is-gone">{body}</span>
  return (
    <Link className="phone-link" to={`/phones?device=${encodeURIComponent(deviceId)}`} title={openPhone}>
      {body}
    </Link>
  )
}
